import React, { ErrorInfo, ReactNode } from 'react'

import { ErrorFallback } from './ErrorFallback'

type ErrorBoundaryWrapperProps = {
  children: ReactNode
}

type ComponentState = {
  error: Error | null
}

export class ErrorBoundaryWrapper extends React.Component<ErrorBoundaryWrapperProps, ComponentState> {
  constructor(props: ErrorBoundaryWrapperProps) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): ComponentState {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Error boundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.error) {
      // You can render any custom fallback UI here
      return <ErrorFallback error={this.state.error} />
    }

    return this.props.children
  }
}
